import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Project } from '../types';
import { useTelegram } from '../hooks/useTelegram';

interface ProjectCardProps {
  project: Project;
  index: number;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project, index }) => {
  const { hapticImpact } = useTelegram();
  const navigate = useNavigate();

  const thumbnail = project.media?.[0]?.url;

  const handleClick = () => {
    hapticImpact('light');
    navigate(`/project/${project.id}`);
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6, delay: 0.55 + index * 0.1, ease: [0, 0, 0.25, 1] }}
      onClick={handleClick}
      style={{
        flexShrink: 0,
        width: '200px',
        scrollSnapAlign: 'start',
        borderRadius: '14px',
        overflow: 'hidden',
        background: '#FFFFFF',
        border: '0.5px solid rgba(0,0,0,0.06)',
        cursor: 'pointer',
        WebkitTapHighlightColor: 'transparent',
      }}
      whileTap={{ scale: 0.96 }}
    >
      {thumbnail ? (
        <img
          src={thumbnail}
          alt={project.title}
          loading="lazy"
          style={{
            width: '100%',
            aspectRatio: '3/2',
            objectFit: 'cover',
            display: 'block',
          }}
        />
      ) : (
        <div
          style={{
            width: '100%',
            aspectRatio: '3/2',
            background: '#F6F6F7',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#AEAEB2',
          }}
        >
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
          </svg>
        </div>
      )}
      <div style={{ padding: '12px 14px 14px' }}>
        <div
          style={{
            fontFamily: "'DM Serif Display', Georgia, serif",
            fontSize: '14px',
            color: '#111111',
            lineHeight: 1.3,
            marginBottom: '3px',
          }}
        >
          {project.title}
        </div>
        <div
          style={{
            fontSize: '11px',
            color: '#AEAEB2',
            fontWeight: 500,
          }}
        >
          {project.category}
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectCard;
